import { z } from "zod";

export const ArenaCompetitionCancelReasonSchema = z.enum(["NOT_ENOUGH_PLAYERS", "SPIN_AND_GO_DISABLED"]);
export type ArenaCompetitionCancelReason = z.infer<typeof ArenaCompetitionCancelReasonSchema>;

/** A scheduled competition cancelled at start (its campaign is deleted); every locked entry fee was refunded. */
export const ArenaCancelledCompetitionDtoSchema = z.object({
  campaignName: z.string(),
  title: z.string(),
  startsAt: z.coerce.date(),
  cancelledAt: z.coerce.date(),
  reason: ArenaCompetitionCancelReasonSchema,
  minPlayers: z.number().int().positive(),
  joinedCount: z.number().int().nonnegative(),
  /** Decimal USDT string; `null` for a free competition. */
  entryFeesUsdt: z.string().nullable(),
  isBattleRoyale: z.boolean(),
});
export type ArenaCancelledCompetitionDto = z.infer<typeof ArenaCancelledCompetitionDtoSchema>;
